import React from "react";
import { BASE_URL } from "../constants";
const Head = ({ websiteSetting }) => {
  return (
    <>
      <section className="head">
        <div className="container flexSB">
          <div className="logo">
            <img
              src={`${
                BASE_URL + "/" + `${websiteSetting?.logo}`
              }`}
              alt="bg"
              style={{
                width: "12%",
                height: "auto",
                objectFit: "contain",
                marginRight: "0.4rem",
              }}
            />
            <div>
              <h1>Al-Munir</h1>
              <span>Educational Excellence with Faith and Purpose</span>
            </div>
          </div>

          <div className="social">
            <a
              href={websiteSetting?.facebookLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook-f icon"></i>
            </a>
            <a
              href={websiteSetting?.youtubeLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-youtube icon"></i>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Head;
